import styled, { css } from 'styled-components';

const styles = css`
  display: flex;
  row-gap: 5px;
  align-items: center;
  width: 100%;
  .page-title {
    text-transform: capitalize;
  }
  .menu {
    font-size: 0.75em;
    display: flex;
    gap: 10px;
    max-height: 100%;
    align-items: center;
    &.right {
      margin-left: auto;
    }

    &.left {
    }
    & .tab {
      display: flex;
      align-items: center;
      text-align: center;
      position: relative;
      border: 1px solid #777777;
      border-radius: 3px;
      color: white;
      padding: 10px;
      user-select: none;

      &.selected {
        border: 1px solid #f0f0f0;
        background-color: white;
        color: black;
      }
      &:hover {
        border-color: white;
      }
    }

    &.tab-bar {
      border-bottom: 1px solid #777777;
      position: relative;
      top: 3px;
      height: calc(100% - 5px);
      width: 100%;
    }

  }

  .menu-item {
    display: flex;
    align-items: center;
    padding-left: 1em;
    padding-right: 1em;
    height: 100%;
    position: relative;

    &.clickable {
      &:hover {
       cursor: pointer;
      }
    }

    &.dropdown {
      & .dropdown {
        display: none;
      }
      :hover {
        & .dropdown {
          display: flex;
        }
      }
    }
  }

  a {
    color: white;
    &:hover {
      color: rgb(150, 150, 255);
    }
  }

 /* LOGO */
  .logo {
    
    & img {
      //width: 100%;
      height: 50px;
      padding: 5px;
    }
    & .env {
      text-transform: uppercase;
      &:before {
        content: ' (';
      }
      &:after {
        content: ') ';
      }
    }
  }`;

const Navbar = styled(({ className, children }) =>
  <div className={className}>{children}</div>)`${styles}`;

export default Navbar;